import { combineReducers } from 'redux'

import foodMoodReducer from './food-mood-reducer'
import foodMoodsReducer from './food-moods-reducer'

export default combineReducers({
  foodMoods: foodMoodsReducer,
  foodMood: foodMoodReducer,
})
